import urlCampaignCodeUtility from '@sparta.sales.utilities/url-campaign-code-utility/dist/es6.js';
import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import Handlebars from '@sparta.global.vendors/handlebars';
import { is } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/links-module",
  "version": "2.0.2",
  "id": "linksModule",
  "containerID": "homeLoansLinksModule",
  "moduleName": "home-loans-links-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "links-module",
  "data": {
    "init": "linksModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        is
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    is
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.sales.utilities/url-campaign-code-utility": "^2.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @class linksModule
 * @extends Module
 */
class linksModule extends Module {
  /**
   * @method constuctor
   * @param {Object} options module params
   * @param {Object} context module params
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#linksModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method updateLink
   * @param {Object} response response object
   * @param {Object} $link link
   * @returns {void}
   */
  updateLink(response = {}, $link) {
    const processed = $link.data('processed');
    const href = $link.attr('href');
    // eslint-disable-next-line no-script-url
    if (!processed && href && href.indexOf('javascript:') === -1 && href.indexOf('tel:') === -1) {
      const {
        scsCampCode,
        subCampCode
      } = response;
      const newHref = urlCampaignCodeUtility.applyCampaignCodes(`${href}`, scsCampCode, subCampCode);
      $link.attr('href', urlCampaignCodeUtility.applyAffiliateCode(newHref, response));
      const params = Utility.getQueryParamValues(window.location.href);
      if (/(dmcode)/i.test(window.location.href)) {
        const dmcode = params && params.dmcode;
        const updatedHref = $link.attr('href');
        $link.attr('href', urlCampaignCodeUtility.applyDirectMarketingCode(updatedHref, dmcode));
      }
      if (/(sourcecd)/i.test(window.location.href)) {
        const sourceCd = params && params.sourceCd;
        const linkHref = $link.attr('href');
        $link.attr('href', urlCampaignCodeUtility.applyDirectSourceCdParam(linkHref, sourceCd));
      }
    }
    $link.data('processed', true);
  }

  /**
   * @method updateApplyOrPrequalifyLink
   * @param {Object} response response object
   * @returns {Function} returnFunc()
   */
  updateApplyOrPrequalifyLink(response = {}) {
    const {
      updateLink
    } = this;
    return function returnFunc() {
      const $link = $(this);
      updateLink(response, $link);
    };
  }

  /**
   * @method updateAffiliateCodeOnly
   * @param {Object} response reponse object
   * @returns {void}
   */
  updateAffiliateCodeOnly(response = {}) {
    return function returnFunc() {
      const $link = $(this);
      const href = $link.attr('href');
      const processed = $link.data('processed');
      // eslint-disable-next-line no-script-url
      if (!processed && href && href.indexOf('javascript:') === -1 && href.indexOf('tel:') === -1 && !/$#/.test(href)) {
        $link.attr('href', urlCampaignCodeUtility.applyAffiliateCode(href, response));
      }
      $link.data('processed', true);
    };
  }

  /**
   * @method updatePhoneNumbers
   * @param {Object} payload - AJAX payload object containing inbound phone number
   * @desc Update phone numbers for this module
   * @returns {void}
   */
  updatePhoneNumbers(payload = {}) {
    // update contact phone numbers
    const phoneNumber = payload.phoneNumber || spaParams.pageParams.foo;
    const $contactUs = $('.call-us, .number, .sc-phone-number, #callUs');
    if (phoneNumber) {
      const barePhone = phoneNumber.replace(/[^\d]/g, '');
      const matches = barePhone.match(/(\d{3})(\d{3})(\d{4})/);
      if (matches && matches.length > 3) {
        const formattedPhone = `${matches[1]}.${matches[2]}.${matches[3]}`;
        $contactUs.each((index, ele) => {
          const hasTextAsContent = $(ele).hasClass('keep-text');
          if (!hasTextAsContent) {
            // eslint-disable-next-line no-param-reassign
            ele.text = formattedPhone;
          }
        });
        $contactUs.attr('href', `tel:1${barePhone}`);
      }
    } else {
      $contactUs.each((idx, el) => {
        const contactPhoneNumber = $(el).text();
        if (contactPhoneNumber) {
          let barePhone = contactPhoneNumber.replace(/[^\d]/g, '');
          // to-do for August release, fix as part of May release
          barePhone = barePhone && barePhone !== '' ? barePhone : '8664660979';
          $contactUs.attr('href', `tel:1${barePhone}`);
        }
      });
    }
  }

  /**
   * @method findValueByKeyCaseInsensitive
   * @param {Object} searchObject - object to be searched
   * @param {String} searchKey - search string
   * @desc Search through the object to find the key that matches searchKey regardless of case.
   * @returns {String} String or empty string if not found
   */
  findValueByKeyCaseInsensitive(searchObject, searchKey) {
    const keys = Object.keys(searchObject || {});
    const regex = new RegExp(searchKey, 'i');
    const matchedKey = keys.find(key => regex.test(key) ? key : false);
    if (matchedKey) {
      return searchObject[matchedKey];
    }
    return '';
  }

  /**
   * Updates all including links coming from content manager footnotes.
   * @method updateAllLinks
   * @param {Object} response - AJAX response containing error and campaign codes
   * @desc Add campaign data to all links
   * @returns {void}
   */
  updateAllLinks(response = {}) {
    this.updateLinks(response);
    this.Events.sub('spartaContentManagerUtility/CMS_Utility_Key_Complete_disclosures/manifests/salesonb/home-loans', () => {
      window.requestAnimationFrame(() => {
        this.updateLinks(response);
      });
    }, true);
  }

  /**
   * @method updateLinks
   * @param {Object} response - AJAX response containing error and campaign codes
   * @desc Add campaign data to all links
   * @returns {void}
   */
  updateLinks(response = {}) {
    const payload = response.data;
    this.updatePhoneNumbers(payload);
    const $secureLinks = $('.secure-sign-in, ' // sign into your account
    + '#globalFooterModule .get-prequalified, ' // get prequalified on footer
    + '#ready-to-apply #ready-to-apply-link, ' // ready to apply link
    + '#large-tab-nav .icon.online-banking a, ' // schedule an appt on large tab
    + '#small-tab-nav .icon.online-banking a, ' // schedule an appt on small tab
    + '#closingCostsFallbackModule #schedule-appt, ' // schedule an appt on fall back
    + '#contactUsModule #schedule-appt, ' // schedule an appt contact us
    + '#engagementModule #prequalify-now-medium, ' // prequalify button
    + '.prequalify-now, ' + '.apply-now, ' + '.apply-or-prequalify, ' + '#engagementModule #apply-now-medium, ' // apply now button
    + '#engagementModule #schedule_an_appointment_engagment, ' // schedule an appt engagement
    + '#manage-prequalification'); // manage prequalification on top nav menu

    const {
      secureHost
    } = spaParams.siteParams;
    $secureLinks.each(function linkEach() {
      const $link = $(this);
      const href = $link.attr('href');
      const pathName = $link[0] && $link[0].pathname;
      const serchUrl = $link[0] && $link[0].search;
      if (pathName && serchUrl && secureHost && !_.includes(href, secureHost)) {
        $link.attr('href', `${secureHost}${pathName}${serchUrl}`);
      }
    });
    if (!(payload.error || _.isEmpty(payload))) {
      const updateApplyOrPrequalifyLink = this.updateApplyOrPrequalifyLink(payload);
      $('.apply-or-prequalify').each(updateApplyOrPrequalifyLink);
      let updateNonSecureLink;
      if (/(subcampcode|scscampcode|dmcode|sourcecd)/i.test(window.location.href)) {
        updateNonSecureLink = updateApplyOrPrequalifyLink;
      } else {
        updateNonSecureLink = this.updateAffiliateCodeOnly(payload);
      }
      $('a').not('.apply-or-prequalify').each(updateNonSecureLink);
    } else if (/(subcampcode)/i.test(window.location.href)) {
      // To fix subCampCode getting dropped when MLO is incorrect
      const {
        query
      } = urlCampaignCodeUtility.parseUrl(window.location.href);
      const subCampCode = {
        subCampCode: this.findValueByKeyCaseInsensitive(query, 'subcampcode')
      };
      $('a').each((_key, value) => {
        this.updateLink(subCampCode, $(value));
      });
    }
  }

  /**
   * @method init
   * @returns {void}
   */
  init() {
    const events = [
    // home loans overview events
    'HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS', 'HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_FAILURE',
    // mortgage, refinance, and home-equity events
    'HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS', 'HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE',
    // home loans learning events
    'HOME_LOANS_LEARNING_MLO_INFO_REQUEST_SUCCESS'];
    events.forEach(event => this.Events.sub(event, this.updateAllLinks));
  }
}
registerModuleClass({
  moduleClass: linksModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { linksModule as default, moduleConfig };
